<app-pan-button
  [state]="isPending() ? 'loading' : 'default'"
  (click)="passwordAction() === 'clear' ? clearVideoPassword() : refreshVideoPassword()"
>
  {{ passwordAction() === 'clear' ? 'Clear' : 'Create or Refresh' }} Video Password
</app-pan-button>
